import { render, staticRenderFns } from "./DescadastroAcompanhamentoPublicacoes.vue?vue&type=template&id=7607be5e&scoped=true"
import script from "./DescadastroAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
export * from "./DescadastroAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
import style0 from "./DescadastroAcompanhamentoPublicacoes.vue?vue&type=style&index=0&id=7607be5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7607be5e",
  null
  
)

export default component.exports